import { ApiRoomContainer, ApiSeason } from '@ibe/api';
import React, { JSX, ReactNode, Ref, RefObject } from 'react';
import { DatePickerRef } from '../DatePicker/DatePicker';
import DateRangeDurationPropsType from '../DateRangeDurationPropsType';
import { ServiceSearchDetailParams } from '@ibe/components';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';

export const PACKAGE_CODE = 'code';
export const SALES_CHANNEL_CODE = 'salesChannelCode';
export const ITEM = 'item';
export const OCCUPANCY = 'occupancy';
export const INVALID_DATE_STRING = 'Invalid Date';

export interface HighlightDatesInformation {
  dateRanges: ({ startDate: string; endDate: string } | null)[];
  highlightIcon: JSX.Element;
}

export type WeekDayConstraints = {
  fromDate?: string;
  toDate?: string;
  weekDays?: number[];
};

export interface DateRangeInputProps {
  customDateFormat?: boolean;
  startDate?: string;
  endDate?: string;
  occupancy?: ApiRoomContainer[];
  onChange?: (startDate: string | undefined, endDate: string | undefined) => void;
  onSubmit?: (startDate: string | undefined, endDate: string | undefined) => void;
  minDate?: Date;
  maxDate?: Date;
  minDateRangeSpan?: number; // number of days needs at least to be selected between start date and the end of this range
  maxDateRangeSpan?: number; // number of days allowed to be selected between start date and the end of this range
  id?: string;
  seasons?: ApiSeason[];
  noDatePickerOverflow?: boolean;
  updateStateFromProps?: boolean;
  datePickerRef?: Ref<DatePickerRef>;
  disabled?: boolean;
  weekDayConstraints?: WeekDayConstraints[];
  duration?: DateRangeDurationPropsType;
  selectsDisabledDaysInRange?: boolean;
  useAdvancedFeatures?: boolean;
  focusSelectedMonth?: boolean;
  monthsShown?: number;
  customDivider?: React.ReactNode;
  CustomInput?: ReactNode;
  CustomHeader?: ReactNode;
  onCalendarClose?: () => void;
  onCalendarCloseDated?: (startDate: string | undefined, endDate: string | undefined) => void;
  popoverRef?: RefObject<HTMLDivElement | null>;
  popoverTargetRef?: RefObject<HTMLElement>;
  dateRangeInputRef?: Ref<{
    togglePopover: () => void;
    openPopover: () => void;
    closePopover: () => [startDate?: string, endDate?: string];
    getCurrentDateRange: () => [startDate?: string, endDate?: string];
  }>;
  stateFromPropsOnPopoverOpen?: boolean;
  useLocalSelectedDatesForInRangeCheck?: boolean;
  onMonthChange?: (date?: Date) => void;
  onYearChange?: () => void;
  onCalendarOpen?: () => void;
  onPopoverToggle?: () => void;
  fillWithLastDateRangeWhenNoSelection?: boolean;
  clearSelectionsOnOpen?: boolean;
  withColorCodedAvailability?: boolean;
  selectedRoomServiceUnitTypeCode?: string;
  showDateSelectionInModal?: boolean;
  modalLabel?: string;
  highlightDatesInformation?: HighlightDatesInformation;
  searchParams?: Partial<ServiceSearchDetailParams>;
  validationErrorComponent?: (errorKeys?: string[]) => ReactNode;
  selectsRange?: boolean;
  showPopperArrow?: boolean;
  withHeader?: boolean;
  renderInline?: boolean;
  minMonthShown?: number; // override default mobile
  customRenderDayContents?: (day: number, _date: Date) => JSX.Element;
  customFilterDate?: (date: Date) => boolean;
  currentlyVisibleMonth?: string;
  renderCustomHeader?: (props: ReactDatePickerCustomHeaderProps) => JSX.Element;
}
